<template>
  <div class="certificate pb-1">
    <div class="logos-wrapper">
      <img :src="require('@/assets/images/logo_labhoh.svg')" />
      <img :src="require('@/assets/images/rva-m-321.svg')" />
    </div>
    <div v-if="data">
      <h2>
        <span class="badge rounded-pill bg-success badge-custom px-5 py-4 mb-3 mt-5" v-if="!expired">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-check-circle-fill me-2" viewBox="0 0 16 16">
            <path
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
            />
          </svg>
          Test successfully validated
        </span>
      </h2>
      <h2>
        <span
          class="badge rounded-pill bg-warning badge-custom px-5 py-4 mb-3 mt-5"
          v-if="expired"
          style="text-shadow: 1px 1px 2px rgba(1, 1, 1, 0.3)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-check-circle-fill me-2" viewBox="0 0 16 16">
            <path
              d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
            />
          </svg>
          Test date expired
        </span>
      </h2>
      <div class="card" style="max-width: 400px">
        <div class="card-header" style="text-align: left; padding: 14px 20px; text-transform: uppercase; font-weight: 600; color: gray">
          Case Info
        </div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <span class="key">Sample ID:</span>
            <span class="value">{{ data.sampleId }}</span>
          </li>
          <li class="list-group-item">
            <span class="key">Sample Date and Time:</span>
            <span class="value" v-html="formatDateTime(data.sampleDate) + ' (UTC)'"></span>
          </li>
          <li class="list-group-item">
            <span class="key">Valid until:</span>
            <span class="value" v-html="formatDateTime(data.sample72hValidation) + ' (UTC)'"></span>
          </li>
          <li class="list-group-item">
            <span class="key">Birthday:</span>
            <span class="value">{{ formatDate(data.patientBirthDay) }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div v-else>
      <h2>
        <span class="badge rounded-pill bg-danger px-5 py-4 mb-3 mt-5">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-check-circle-fill me-2" viewBox="0 0 16 16">
            <path
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
            />
          </svg>
          Test not valid
        </span>
      </h2>
    </div>
    <div class="contact-info-wrapper mb-5">
      <div class="item"><span>Telephone:</span> +297 597 4522</div>
      <div class="item"><span>E-mail:</span> servicecenter@hoharuba.com</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  props: ['data'],
  data() {
    return {
      expired: false,
    };
  },
  created() {
    if (this.data) this.checkTextExpireDate();
  },
  methods: {
    formatDateTime(d) {
      return moment.utc(d, 'YYYY-MM-DDTHH:mm').format('DD-MMM-YYYY | h:mm A');
    },
    formatDate(d) {
      return moment.utc(d, 'YYYY-MM-DDTHH:mm').format('DD-MMM-YYYY');
    },
    checkTextExpireDate() {
      const expireDateTime = moment(this.data.sample72hValidation, 'YYYY-MM-DDTHH:mm');
      if (moment.utc() > expireDateTime) this.expired = true;
      else this.expired = false;
    },
  },
};
</script>

<style lang="scss">
.certificate {
  .logos-wrapper {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    height: 175px;
    img {
      max-width: 200px;
      width: 100%;
    }
  }
  .card {
    margin: 20px auto;
    .list-group-item {
      border-top: 1px solid rgba(0, 0, 0, 0.125) !important;
      text-align: left;
      padding: 14px 20px;
      font-weight: 500;
      span {
        display: block;
      }
      span.key {
        font-weight: 400;
        color: grey;
      }
      span.value {
      }
    }
  }
  .contact-info-wrapper {
    //background: #f2f2f2;
    font-size: 18px;
    padding: 20px;
    margin: 40px auto;
    max-width: 500px;
    //font-weight: 600;
    color: #36a0dd;
    border: 1px solid #36a0dd;
    border-radius: 14px;

    span {
      text-transform: uppercase;
      //font-weight: 600;
      color: grey;
      font-size: 13px;
    }
  }
}

/* Extra Small Devices, Phones */
@media only screen and (max-width: 480px) {
  .certificate {
    .logos-wrapper {
      height: 130px;
      img {
        max-width: 140px;
      }
    }
    .card {
      .list-group-item {
        display: block;
        //justify-content: space-between;
      }
    }
    .badge-custom {
      display: block;
      padding: 10px !important;
    }
    .contact-info-wrapper {
      font-size: 16px;
      span {
        display: block;
      }
    }
  }
}
</style>